export default __webpack_public_path__ + "static/media/info-circle.fd4681c3.svg";